import { ReactNode } from 'react';

import * as SC from './styled';

interface IProps {
    icon: string,
    children: ReactNode,
}

const SpendCard = ({ icon, children }: IProps): JSX.Element => {
    return (
        <SC.CardWrapper>
            <SC.CardIcon icon={icon}/>
            <SC.CardText>{children}</SC.CardText>
        </SC.CardWrapper>
    );
};

export default SpendCard;
